import React from "react";
import { howItWorksData, companyInfo } from "../data/mock";
import {
  MessageSquare,
  ClipboardCheck,
  Truck,
  BadgeCheck,
  ArrowRight,
} from "lucide-react";
import { Button } from "./ui/button";

const iconMap = {
  MessageSquare,
  ClipboardCheck,
  Truck,
  BadgeCheck,
};

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-emerald-900 relative overflow-hidden">
      {/* Decorative shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-800/40 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-teal-800/30 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 bg-emerald-800/60 backdrop-blur-sm border border-emerald-700/40 rounded-full px-4 py-1.5 mb-6">
            <div className="w-2 h-2 rounded-full bg-emerald-400" />
            <span className="text-emerald-300 text-sm font-semibold uppercase tracking-wider">
              Simple Process
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            How It Works
          </h2>
          <p className="text-emerald-200/70 text-lg max-w-2xl mx-auto">
            Selling your scrap is as easy as 1-2-3-4. We handle everything from pickup to payment.
          </p>
        </div>

        {/* Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {howItWorksData.map((step, i) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={i} className="relative group">
                {/* Connector line */}
                {i < howItWorksData.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-[60%] w-[calc(100%-20%)] h-[2px] bg-emerald-700/50" />
                )}

                <div className="text-center">
                  {/* Step number + icon */}
                  <div className="relative inline-flex mb-8">
                    <div className="w-20 h-20 rounded-2xl bg-emerald-800/60 backdrop-blur-sm border border-emerald-700/40 flex items-center justify-center group-hover:bg-emerald-700/60 transition-colors duration-300">
                      {Icon && (
                        <Icon className="w-8 h-8 text-emerald-300" />
                      )}
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-lg bg-amber-500 flex items-center justify-center text-sm font-bold text-white shadow-lg">
                      {step.step}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-emerald-200/60 text-[15px] leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href={`https://wa.me/${companyInfo.whatsapp}?text=Hi%20AM%20Scrap%20Dealers%2C%20I%20would%20like%20to%20schedule%20a%20scrap%20pickup.`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              size="lg"
              className="bg-amber-500 hover:bg-amber-400 text-slate-900 rounded-xl px-8 py-6 text-base font-bold shadow-xl shadow-amber-900/20 transition-all duration-300 hover:-translate-y-0.5"
            >
              Start Your Pickup Now
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
